import type { Customer } from 'src/shared/types';
import type { Organisation } from 'src/shared/types/engine/organisation';

export type LegacyCustomer = Pick<Customer, 'customerId' | 'customerName'>;

export type EngineOrganisation = Pick<Organisation, 'business_central_id' | 'name' | 'deleted_at'>;

export type CustomerAndOrganisation = { customer: LegacyCustomer; organisation: EngineOrganisation };

export type EstateDiscrepancies = {
    matched: number;
    missingInEngine: LegacyCustomer[];
    archivedInEngine: CustomerAndOrganisation[];
    engineOnly: EngineOrganisation[];
    nameDiffers: CustomerAndOrganisation[];
};

export const findEstateDiscrepancies = (customers: LegacyCustomer[], organisations: EngineOrganisation[]): EstateDiscrepancies => {
    const organisationsById = new Map(organisations.map(organisation => [organisation.business_central_id, organisation]));
    const result: EstateDiscrepancies = { matched: 0, missingInEngine: [], archivedInEngine: [], engineOnly: [], nameDiffers: [] };

    for (const customer of customers) {
        const organisation = organisationsById.get(customer.customerId);
        if (!organisation) {
            result.missingInEngine.push(customer);
        } else if (organisation.deleted_at !== null) {
            result.archivedInEngine.push({ customer, organisation });
        } else if (organisation.name !== customer.customerName) {
            result.nameDiffers.push({ customer, organisation });
        } else {
            result.matched += 1;
        }
    }

    const customerIds = new Set(customers.map(customer => customer.customerId));
    result.engineOnly = organisations.filter(
        organisation => organisation.deleted_at === null && !customerIds.has(organisation.business_central_id)
    );

    return result;
};
